
import { Routes, Route } from "react-router-dom";
import './style/main.scss';

import Home from './pages/Home';
import Home1 from './pages/Home1';
import Login from "./pages/Login";
import RegisterOrg from "./pages/RegisterOrg";
import WIP from './pages/WIP';

//Fram Activity
import Traceability from "./pages/farmActivity/Traceability";
import Meeting from "./pages/farmActivity/Meeting";
import Training from "./pages/farmActivity/Training";
import Distribution from "./pages/farmActivity/Distribution";

//Livestock
import LivestockCount from "./pages/livestock/LivestockCount";
import LivestockActivity from "./pages/livestock/LivestockActivity";
import LivestockAlert from "./pages/livestock/LivestockAlert";

//Advisory
import InputCategory from './pages/advisory/InputCategory';

//Master
import Farmer from "./pages/master/Farmer";
import Pg_Vo from "./pages/master/Pg_Vo";
import Employee from "./pages/master/Employee";
import UserManagement from "./pages/master/UserManagement";
import CropMaster from "./pages/master/CropMaster";
import CropVariety from "./pages/master/CropVariety";

//Accounting
import BalanceSheet from "./pages/accounting/BalanceSheet";
import ChartsOfAccount from "./pages/accounting/ChartsOfAccount";
import ProfitLoss from "./pages/accounting/ProfitLoss";
import TrialBalance from "./pages/accounting/TrialBalance";
import JournalList from "./pages/accounting/journalList/JournalList";
import PaymentScreen from "./pages/accounting/inputScreens/PaymentScreen";

//Setting
import Profile from "./pages/setting/Profile";
import Uom from "./pages/setting/Uom";
import Language from "./pages/setting/Language";
import Organisation from "./pages/setting/Oraganization";
import PackageOfPractice from "./pages/setting/PackageOfPractice";
import Demand from "./pages/setting/Demand";
import InputSalePurchase from "./pages/setting/InputSalePurchase";
import ProduceSalePurchase from "./pages/setting/ProduceSalePurchase";

//Report
import FarmerSowingReport from "./pages/report/FarmerSowingReport";
import MonthlyLivestockReport from "./pages/report/MonthlyLivestockReport";
import MonthlyAgricultureReport from "./pages/report/MonthlyAgricultureReport";


function App() {
  return (
    <div className="App" style={{marginTop: "70px"}}>
      <Routes>
        <Route path="/" element={ <Login /> } />
        <Route path="/register" element={ <RegisterOrg /> } />
        <Route path="/home" element={ <Home /> } />
        <Route path="/home1" element={ <Home1 /> } />
        
        <Route path="/traceability" element={ <Traceability /> } />
        <Route path="/meeting" element={ <Meeting /> } />
        <Route path="/training" element={ <Training /> } />
        <Route path="/distribution" element={ <Distribution /> } />

        <Route path="/livestock-count" element={ <LivestockCount /> } />
        <Route path="/livestock-activity" element={ <LivestockActivity /> } />
        <Route path="/livestock-alert" element={ <LivestockAlert /> } />
        
        <Route path="/input" element={ <InputCategory /> } />

        <Route path="/farmer" element={ <Farmer /> } />
        <Route path="/pg" element={ <Pg_Vo /> } />
        <Route path="/employee" element={ <Employee /> } />
        <Route path="/user-management" element={ <UserManagement /> } />
        <Route path="/crop-master" element={ <CropMaster /> } />
        <Route path="/crop-variety" element={ <CropVariety /> } />
        
        <Route path="/profile" element={ <Profile /> } />
        <Route path="/uom" element={ <Uom /> } />
        <Route path="/languages" element={ <Language /> } />
        <Route path="/Organisation" element={ <Organisation /> } />
        <Route path="/pop" element={ <PackageOfPractice /> } />
        <Route path="/demand" element={ <Demand /> } />
        <Route path="/input-sale-purchase" element={ <InputSalePurchase /> } />
        <Route path="/produce-sale-purchase" element={ <ProduceSalePurchase /> } />

        <Route path="/balance-sheet" element={ <BalanceSheet /> } />
        <Route path="/charts-of-account" element={ <ChartsOfAccount /> } />
        <Route path="/profit-loss" element={ <ProfitLoss /> } />
        <Route path="/trial-balance" element={ <TrialBalance /> } />
        <Route path="/journal-list" element={ <JournalList /> } />
        <Route path="/payment" element={ <PaymentScreen /> } />

        <Route path="/farmer-sowing-report" element={ <FarmerSowingReport /> } />
        <Route path="/monthly-livestock-report" element={ <MonthlyLivestockReport /> } />
        <Route path="/monthly-agriculture-report" element={ <MonthlyAgricultureReport /> } />

        <Route path="*" element={ <WIP /> } />
      </Routes>

      {/* <Header /> */}
      {/* <Page title='TestingPage' breadcrumbs='hello' children='hello-children' /> */}
    </div>
  );
}

export default App;